var t = /* @__PURE__ */ ((e) => (e.ANALYTICS = "analytics", e.EXPERIMENT = "experiment", e.AUDIENCES = "audiences", e.DATA = "data", e.EXPLORER = "explorer", e))(t || {}), a = /* @__PURE__ */ ((e) => (e.PRODUCTION = "production", e.PROD_EU = "prod-eu", e.PROD_SANDBOX = "prod-sandbox", e.STAGING = "staging", e.DEVELOPMENT = "development", e.LOCAL = "local", e))(a || {});
const p = {
  analytics: {
    value: "analytics",
    urls: {
      production: "https://analytics.amplitude.com",
      "prod-eu": "https://analytics.eu.amplitude.com",
      "prod-sandbox": "https://analytics.prod-sandbox.amplitude.com",
      staging: "https://analytics.staging.amplitude.com",
      development: "https://analytics.dev.amplitude.com",
      local: "http://localhost:3001",
      onenav: "/analytics"
    },
    label: "Analytics",
    icon: "analytics"
  },
  experiment: {
    value: "experiment",
    urls: {
      production: "https://experiment.amplitude.com",
      "prod-eu": "https://experiment.eu.amplitude.com",
      "prod-sandbox": "https://experiment.prod-sandbox.amplitude.com",
      staging: "https://experiment.staging.amplitude.com",
      development: "https://experiment.dev.amplitude.com",
      local: "http://localhost:3003",
      onenav: "/experiment"
    },
    label: "Experiment",
    icon: "experiment"
  },
  audiences: {
    value: "audiences",
    urls: {
      production: "https://audiences.amplitude.com",
      "prod-eu": "https://audiences.eu.amplitude.com",
      "prod-sandbox": "https://audiences.prod-sandbox.amplitude.com",
      staging: "https://audiences.staging.amplitude.com",
      development: "https://audiences.dev.amplitude.com",
      local: "http://localhost:3004",
      onenav: "/audiences"
    },
    label: "Audiences",
    icon: "audiences"
  },
  data: {
    value: "data",
    urls: {
      production: "https://data.amplitude.com",
      "prod-eu": "https://data.eu.amplitude.com",
      "prod-sandbox": "https://data.prod-sandbox.amplitude.com",
      staging: "https://data.staging.amplitude.com",
      development: "https://data.dev.amplitude.com",
      local: "http://localhost:3005",
      onenav: "/data"
    },
    label: "Data",
    icon: "data"
  },
  explorer: {
    value: "explorer",
    urls: {
      production: "https://explorer.amplitude.com",
      "prod-eu": "https://explorer.eu.amplitude.com",
      "prod-sandbox": "https://explorer.prod-sandbox.amplitude.com",
      staging: "https://explorer.staging.amplitude.com",
      development: "https://explorer.dev.amplitude.com",
      local: "http://localhost:3006",
      onenav: "/explorer"
    },
    label: "Explorer",
    icon: "data"
  }
}, o = Object.values(p);
export {
  a as Environment,
  t as Product,
  p as ProductInfo,
  o as Products
};
//# sourceMappingURL=product.js.map
